import React, { useState, useEffect } from 'react'
import styles from '../../../Css/CustomSettings.module.css'
import Styles from '../../../Css/UploadScreen.module.css'
import LogoCropModal from '../../Modals/LogoCropModal'
import Slider from "react-slick";
import OverlayModal from '../../Modals/OverlayModal';
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons';
import ToggleButton from 'react-toggle-button'
import { style } from 'dom-helpers';
import CarPostProcessingBrightness from '../../Common/CarPostProcessingBrightness'
import CarPostProcessingTint from '../../Common/CarPosrProcessingTint'
import {Tooltip} from 'react-bootstrap'
// Slider Script Start
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "inline-block" }}
            onClick={onClick}
        />
    );
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={"slider-icon"}
            style={{ ...style, display: "inline-block", border: "0", top: "50px", right: "-10px", color: "#333", background: "transparent" }}
            onClick={onClick}
        >
            <i class="fa fa-angle-double-right"></i>
        </div>
    );
}
// Slider script End  

const shadowList = [{type: "soft",
imgUrl: "https://storage.googleapis.com/spyne-website/self-serve/fashion-shdaow-soft.png"},{type: "medium",
imgUrl: "https://storage.googleapis.com/spyne-website/self-serve/fashion-shdaow-medium.png"},
{type: "hard",
imgUrl: "https://storage.googleapis.com/spyne-website/self-serve/fashion-shdaow-hard.png"}]

function VirtualStudio(props) {

    const [showlogoCropModal, setShowlogoCropModal] = useState(false);
    const [logoUrl, setLogoUrl] = useState(null);
    const [file, setFile] = useState(null);
    const [overlayPopupHandlar, setOverlayPopupHandlar] = useState(false);
    const [modalImage, setModalImage] = useState(null);
    const hiddenFileInput = React.useRef(null);
    const [croppedLogo, setCroppedLogo] = useState(null)
    const [croppedImageUrl, setCroppedImageUrl] = useState(null)
    const [numberPlateLogoUrl, setNumberPlateLogoUrl] = useState('')
    const [brightnessControl, setBrigtnessControl] = useState(50)
    const [tintValue, setTint] = useState(50)

    const handleClick = (event) => {
        hiddenFileInput.current.click();
    };
    const handleOverlayPopup = (event) => {
        setTimeout(() => {
            setOverlayPopupHandlar(false)
        }, 300)

    };

    const onFileSelected = (e) => {
        if (e.target) {
            setFile(URL.createObjectURL(e.target.files[0]))
            setNumberPlateLogoUrl(URL.createObjectURL(e.target.files[0]))
        }
        else {
            setFile(URL.createObjectURL(e[0]))
            setNumberPlateLogoUrl(URL.createObjectURL(e[0]))

        }
        setShowlogoCropModal(true)


    };

    const overlayPopup = (imageUrl) => {

        setModalImage(imageUrl)
        setOverlayPopupHandlar(!overlayPopupHandlar)
    }
    const handleCropModal = () => {
        setShowlogoCropModal(false)
    }

    const saveCroppedImage = (blob, croppedImageUrl) => {
        const objectURL = URL.createObjectURL(blob)
        props.handleNumberPlateLogo(blob)
        setNumberPlateLogoUrl(objectURL)
        setShowlogoCropModal(false)
    }

    const handleCroppedLogoBlob = (blob, croppedImageUrl) => {
        setCroppedLogo(blob)
        setCroppedImageUrl(croppedImageUrl)
    }

    const handleBrightness = (value) => {
        setBrigtnessControl(value)
        let brightnessLevel = value
        
        if (brightnessLevel < 33) {
            props.setCheckBrightness("0.9")
        }
        else if (brightnessLevel < 66) {
            props.setCheckBrightness("1")
        }
        else{
            props.setCheckBrightness("1.2")
        }
    }

    const handleTint = (value) => {
        setTint(value)
        
        if (value < 0) {
            props.setCheckTint("0")
        }
        else if (value < 25) {
            props.setCheckTint("0.28")
        }
        else if (value < 50) {
            props.setCheckTint("0.32")
        }
        else{
            props.setCheckTint("0.37")
        }
    }
    // Slider Const 
    const settings2 = {
        infinite: props.modelData?.length <= 3 ? false : true,
        slidesToShow: 3,
        // variableWidth: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: false,
        speed: 500, responsive: [
            {
                breakpoint: 1024,
                settings2: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings2: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 320,
                settings2: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ],
        nextArrow: <SampleNextArrow className="slider-arrow slider-prev fa fa-angle-left" />,
        prevArrow: <SamplePrevArrow className="slider-arrow slider-next fa fa-angle-right" />
    };
    //End Slider


    const spyne_backLeft = props.bgList.length - 9
    // const spyne_favLeft = props.favBgList.length - 9

    // Slider Const 
    const settings = {

        infinite: props.modelPose?.length <= 3 ? false : true,
        slidesToShow: 3,
        // variableWidth: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: false,
        speed: 500, responsive: [
            {
                breakpoint: 1024,
                settings3: {
                    slidesToShow: props.modelPose?.length > 3 ? 3 : props.modelPose?.length,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings3: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 320,
                settings3: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ],
        nextArrow: <SampleNextArrow className="slider-arrow slider-prev fa fa-angle-left" />,
        prevArrow: <SamplePrevArrow className="slider-arrow slider-next fa fa-angle-right" />
    };
    //End Slider

    return (
        <div className={[styles['custom-main-div'], ''].join(' ')}>

            <div className={[styles['main-bg-row'], 'row m-0'].join(' ')}>



                {/* select model */}
                {props.frontendData.models ?
                    <div className={[Styles['try-more-col'], 'col-md-12'].join(' ')} >
                        <div className={[Styles['try-more-images'], styles['solid-bg'], 'row'].join(' ')}>
                            {
                                props.categoryType !== "homeFurnishing" ?
                                    <h6>Select <span>Model </span></h6>
                                    :
                                    <h6>Select <span>Setup </span></h6>
                            }
                            <Slider {...settings2} className={[styles['automobile-slider'], 'col-md-12'].join(' ')} >
                                {
                                    props.modelData.map((model, i) => {
                                        return (

                                            <div key={i + "modelSelected"} className={props.modelId == model.model_id ? [Styles['try-more-col2'], Styles['active'], ''].join(' ') : [Styles['try-more-col2'], ''].join(' ')}>
                                                <div onClick={() => {
                                                    props.set_modelId(model.model_id, model.poses)
                                                    props.handleImageModalInImageSection(model.model_display,true)
                                                }}
                                                onMouseLeave = {()=> {
                                                    props.handleImageModalInImageSection(model.model_display,false)
                                                }}
                                                 className={styles['pose-img']}>
                                                    <img src={model.model_display} />
                                                    {props.modelId == model.model_id ?
                                                        <img src="https://storage.googleapis.com/spyne-website/self-serve/check.png" className={[Styles['check']]} />
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </div>

                                        )
                                    })
                                }
                            </Slider>
                        </div>

                    </div>
                    : null

                }
                {/* Modal Component Call */}
                {overlayPopupHandlar &&
                    <OverlayModal
                        overlayPopupHandlar={overlayPopupHandlar}
                        image={modalImage}
                        handleOverlayPopup={handleOverlayPopup}
                        overlayPopup={overlayPopup} />

                }

                {/* select pose */}
                {props.frontendData.poses ?
                    <div className={[Styles['try-more-col'], 'col-md-12'].join(' ')} >
                        <div className={[Styles['try-more-images'], styles['solid-bg'], 'row'].join(' ')}>
                            {
                                props.categoryType !== "homeFurnishing" ?
                                    <h6>Model <span>Pose ( You can choose multiple )</span></h6>
                                    :
                                    <h6>Select <span>Template ( You can choose multiple )</span></h6>
                            }
                            <Slider {...settings} className={[styles['automobile-slider'], 'col-md-12'].join(' ')}>
                                {
                                    props.modelPose.map((pose, i) => {
                                        return (

                                            <div key={i + "poseSelected"} className={props.poseToDisplay.indexOf(pose.pose_id) > -1 ? [Styles['try-more-col2'], Styles['active'], ''].join(' ') : [Styles['try-more-col2'], ''].join(' ')}>
                                                <div onClick={() => {
                                                    props.add_poses(pose.pose_id)
                                                    props.handleImageModalInImageSection(pose.display_image,true)
                                                }}
                                                onMouseLeave = {()=> {
                                                    props.handleImageModalInImageSection(pose.display_image,false)
                                                }} 
                                                className={styles['pose-img']}>
                                                    <img src={pose.display_image} />
                                                    {props.poseToDisplay.indexOf(pose.pose_id) > -1 ?
                                                        <img src="https://storage.googleapis.com/spyne-website/self-serve/check.png" className={[Styles['check']]} />
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </div>

                                        )
                                    })
                                }
                            </Slider>
                        </div>

                    </div>
                    : null

                }



                {/* Select Angle  */}
                {props.frontendData.angle ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12'].join(' ')}>
                        <h6> <span>Select</span> Angle</h6>
                        <div className={[styles['solid-bg-image3'], 'row m-0'].join(' ')}>
                            <div className={props.angle === 0 ? [styles['solid-image'], styles['active'], 'solid-image'].join(' ') : [styles['solid-image'], styles[''], 'solid-image '].join(' ')} onClick={() => props.handleAngle(0)}>
                                <img src="https://storage.googleapis.com/spyne-website/Food-Try/90-degree.png" />
                                <p>0 Degree Angle</p>

                            </div>
                            <div className={props.angle === 45 ? [styles['solid-image'], styles['active'], 'solid-image'].join(' ') : [styles['solid-image'], styles[''], 'solid-image '].join(' ')} onClick={() => props.handleAngle(45)}>
                                <img src="https://storage.googleapis.com/spyne-website/Food-Try/45-degree.png" />
                                <p>45 Degree Angle</p>

                            </div>
                            <div className={props.angle === 90 ? [styles['solid-image'], styles['active'], 'solid-image'].join(' ') : [styles['solid-image'], styles[''], 'solid-image '].join(' ')} onClick={() => props.handleAngle(90)}>
                                <img src="https://storage.googleapis.com/spyne-website/Food-Try/0-degree.png" />
                                <p>90 Degree Angle</p>

                            </div>

                        </div>
                    </div>
                    : null
                }
                {/* Spyne's Background Row  */}
                {props.frontendData.backgrounds ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12'].join(' ')}>
                        <h6>Spyne <span>Backgrounds </span></h6>
                        <div className={[styles['solid-bg-image2'], 'row m-0'].join(' ')}>
                            {props.favBgList.slice(0, 9).map((e, i) => {
                                return <>
                                    {props.isLoggedIn ?
                                        <div key={i + "backgroundSelected"} className={props.backgroundId === e.image_id ? [styles['solid-image'], styles['active'], 'solid-image active'].join(' ') : [styles['solid-image'], 'solid-image'].join(' ')} onClick={() => {
                                            props.handleBackground(e.image_id, e.image_credit, e.image_url) 
                                            props.handleImageModalInImageSection(e.image_url,true)
                                        }} 
                                        onMouseLeave = {()=> {
                                            
                                            props.handleImageModalInImageSection(e.image_url,false)
                                        }}>
                                            <img src={e.image_url} />
                                            <p>{e.background_name} </p>
                                            <p className={[styles[''], 'fav-icon-active'].join(' ')} onClick={() => props.handleCarsFavList(i, e.image_id)}>
                                                <i className="fa fa-heart" aria-hidden="true"></i>
                                            </p>
                                        </div>
                                        : null
                                    }
                                </>
                            })}
                            {props.bgList.slice(0, 9 - props.favBgList.length).map((e, i) => {
                                return <div key={i + "favBgSelected"} className={props.backgroundId === e.image_id ? [styles['solid-image'], styles['active'], 'solid-image active'].join(' ') : [styles['solid-image'], 'solid-image'].join(' ')} onClick={() => {
                                    props.handleBackground(e.image_id, e.image_credit, e.image_url) 
                                    props.handleImageModalInImageSection(e.image_url,true)
                                }} 
                                onMouseLeave = {()=> {
                                    
                                    props.handleImageModalInImageSection(e.image_url,false)
                                }}>
                                    <img src={e.image_url} />
                                    <p>{e.background_name} </p>
                                    {props.isLoggedIn ?
                                        <p className={[styles['fav-icon'], 'fav-icon'].join(' ')} onClick={() => props.handleCarsBgList(i, e.image_id)}>
                                            <i className={[styles['heart'], 'fa fa-heart'].join(' ')} aria-hidden="true"></i>
                                        </p>
                                        : null
                                    }

                                </div>
                            })}
                            {props.bgList.length > 9 ?
                                <div className={[styles['spyne-image'], 'solid-image'].join(' ')} onClick={props.handleBackgroundList}>
                                    <img src="https://storage.googleapis.com/spyne-website/self-serve/more-blue.png" />
                                    <h6>{spyne_backLeft}+ more</h6>
                                </div>
                                : null
                            }
                        </div>
                        {props.isLoggedIn && props.prodCatId !== "cat_skJ7HIvnc" ?
                            <h5><i className="fa fa-heart" aria-hidden="false"></i> Click on heart tab to add as your favourite</h5>
                            : null}
                    </div>
                    : null
                }

                {/* Solid Background Row  */}

                {props.frontendData.solidColorBackgrounds?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12'].join(' ')}>
                        <h6>Solid Color <span>Backgrounds </span></h6>
                        <div className={[styles['solid-bg-image2'], 'row m-0'].join(' ')}>
                            {props.colorList.map((e, i) => {
                                return (
                                    <div className={props.backgroundId === e.color_id ? [styles['solid-image'], styles['active'], 'solid-image active'].join(' ') : [styles['solid-image'], 'solid-image'].join(' ')} onClick={() => props.handleColorBackground(e.color_id, e.color_hex_code, e.color_hres_img)}>
                                        <img src={e.color_lres_img} />
                                        <p>{e.color_name} </p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    : null}

                {/* Shadow Category Row  */}
                {props.frontendData.shadows ? 
                <div className={[styles['solid-bg'], 'col-md-12 col-lg-12'].join(' ')}>                
                <div className={Styles['shadow-category-header']}><div><h6><span>Generate </span>Shadow</h6></div>
                <div>
                <ToggleButton  value= {props.applyShadow} onToggle = {(currentValue)=>{
                    props.handleShadowType(null)
                    props.setApplyShadow(!currentValue)
                    
                }}
                 colors={{
                    activeThumb: {
                      base: '#F2994A',
                    //   boxShadow: "0px 1px 2px rgba(255, 146, 0, 0.25)"
                      boxShadow: "0px 0px 1px 7px #cacaca"
                    },
                    inactiveThumb: {
                      base: '#F2994A',
                      border: "1px solid black"
                    },
                    active: {
                      base: '#FBE7D4',
                      
                      hover: 'rgb(252, 207, 151)',
                    },
                    inactive: {
                      base: '#F2F2F2',
                      hover: '#E7E7E7',
                    }
                  }}
                  thumbStyle = {{
                    // boxShadow: "0px 0px 1px 7px #E7E7E7"
                  }}
                />
                </div>
                </div>
                <div className={[styles['solid-bg-image2'], 'row m-0'].join(' ')}>
                    {shadowList.map((e, i) => {
                        return (
                            <div className={props.shadowType === e.type ? [styles['solid-image'], styles['active'], 'solid-image active'].join(' ') : [styles['solid-image'], 'solid-image'].join(' ')} onClick={() => {
                                props.handleShadowType(e.type)
                                props.handleImageModalInImageSection(e.imgUrl,true)
                            }}
                            onMouseLeave = {()=> {
                                
                                props.handleImageModalInImageSection(e.imgUrl,false)
                            }}
                            >
                                <img src={e.imgUrl} />
                                <p>{e.type} </p>
                            </div>
                        )
                    })}
                </div>
            </div>: null
                                
                           
                }
                {/* {props.prodCatId === "cat_skJ7HIvnc" ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12'].join(' ')}>                
                        <div className={Styles['shadow-category-header']}><div><h6><span>Generate </span>Shadow</h6></div>
                        <div>
                        <ToggleButton  value= {props.applyShadow} onToggle = {(currentValue)=>{
                            props.handleShadowType(null)
                            props.setApplyShadow(!currentValue)
                            
                        }}
                         colors={{
                            activeThumb: {
                              base: '#F2994A',
                            //   boxShadow: "0px 1px 2px rgba(255, 146, 0, 0.25)"
                              boxShadow: "0px 0px 1px 7px #cacaca"
                            },
                            inactiveThumb: {
                              base: '#F2994A',
                              border: "1px solid black"
                            },
                            active: {
                              base: '#FBE7D4',
                              
                              hover: 'rgb(252, 207, 151)',
                            },
                            inactive: {
                              base: '#F2F2F2',
                              hover: '#E7E7E7',
                            }
                          }}
                          thumbStyle = {{
                            // boxShadow: "0px 0px 1px 7px #E7E7E7"
                          }}
                        />
                        </div>
                        </div>
                        <div className={[styles['solid-bg-image2'], 'row m-0'].join(' ')}>
                            {shadowList.map((e, i) => {
                                return (
                                    <div className={props.shadowType === e.type ? [styles['solid-image'], styles['active'], 'solid-image active'].join(' ') : [styles['solid-image'], 'solid-image'].join(' ')} onClick={() => {
                                        props.handleShadowType(e.type)
                                        props.handleImageModalInImageSection(e.imgUrl,true)
                                    }}
                                    onMouseLeave = {()=> {
                                        
                                        props.handleImageModalInImageSection(e.imgUrl,false)
                                    }}
                                    >
                                        <img src={e.imgUrl} />
                                        <p>{e.type} </p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    : null} */}

                {/* Choose your number plate  */}
                {props.frontendData.numberPlate ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12 border-0'].join(' ')}>
                        <h6><span>Choose Your Number Plate </span>(+1 Credit) </h6>
                        <div className={[styles['number-plate'], 'row m-0'].join(' ')}>
                            <div className={props.numberPlate === 'blur' ? [styles['solid-image'], styles['active'], 'col-5 col-md-5'].join(' ') : [styles['solid-image'], 'col-5 col-md-5'].join(' ')} onClick={() => props.handleNumberPlate('blur')}>
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/blurr.png" />
                                <p> Number Plate Blur</p>
                            </div>
                            <div className={[styles['or-area'], 'col-md-2 col-2'].join(' ')}><span>OR</span></div>
                            <div className={props.numberPlate === 'logo' ? [styles['solid-image'], styles['active'], 'col-5 col-md-5'].join(' ') : [styles['solid-image'], 'col-md-5 col-5'].join(' ')} onClick={() => props.handleNumberPlate('logo')}>
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/plate-logo.png" />
                                <p>Number Plate Logo</p>
                            </div>
                        </div>
                    </div>
                    : null
                }
                {/* Upload Number Plate Logo */}
                {props.numberPlate === 'logo' ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12 border-0'].join(' ')}>
                        <h6><span>Upload Number Plate Logo</span> </h6>
                        <div className={[styles['number-logo'], 'row m-0'].join(' ')}>
                            <div onClick={handleClick} className={[styles['number-logo-upload'], 'col-md-6'].join(' ')}>
                                {
                                    numberPlateLogoUrl ?
                                        <>
                                            <img className={[styles['logo-url']]} src={numberPlateLogoUrl}></img>
                                            <input
                                                type="file"
                                                ref={hiddenFileInput}
                                                onChange={onFileSelected}
                                                style={{ display: 'none' }}
                                            />
                                        </>

                                        :
                                        <>
                                            <p>No File Chosen</p>
                                            <small>
                                                <input
                                                    type="file"
                                                    ref={hiddenFileInput}
                                                    onChange={onFileSelected}
                                                    style={{ display: 'none' }}
                                                />
                                                <span>Browse Files</span>
                                            </small>
                                        </>
                                }

                            </div>
                        </div>
                    </div>
                    : null
                }

                {props.isDelearshipLogo ?

                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12 border-0'].join(' ')}>
                        <h6><span>Add Brand Logo</span> </h6>
                        <div className={[styles['number-logo'], 'row m-0'].join(' ')}>
                            <div className={[styles['number-logo-upload'], 'col-md-6'].join(' ')}>
                                <p>No File Chosen</p>
                                <small>Drag & drop here. <b>OR</b> <span>Browse Files</span></small>
                            </div>
                            <div className={[styles['solid-bg-image'], 'col-md-6'].join(' ')}>
                                <div className={[styles['logo-image'], ''].join(' ')}>
                                    <img className={[styles['active'], ''].join(' ')} src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/top-left.png" />
                                    <p>top left</p>
                                </div>
                                <div className={[styles['logo-image'], ''].join(' ')}>
                                    <img className={[styles[''], ''].join(' ')} src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/top-right.png" />
                                    <p>top right</p>
                                </div>
                                <div className={[styles['logo-image'], ''].join(' ')}>
                                    <img className={[styles[''], ''].join(' ')} src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/bottom-left.png" />
                                    <p>bottom-left</p>
                                </div>
                                <div className={[styles['logo-image'], ''].join(' ')}>
                                    <img className={[styles[''], ''].join(' ')} src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/bottom-right.png" />
                                    <p>bottom-right</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }

                {/* Background Blur */}
                {props.frontendData.backgroundBlur ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12 border-0'].join(' ')}>
                        <h6><span>Background Blur</span> </h6>

                        <div className={[styles['number-logo'], 'row m-0'].join(' ')}>
                            <div className={[styles['bg-blurr'], 'col-md-3 bg-blurr bg-blurr2'].join(' ')}>
                                <input type="radio" id="noblur" name="Enhancements" value="" />
                                <label htmlFor="noblur">No Blur</label>
                            </div>
                            <div className={[styles['bg-blurr'], 'col-md-3 bg-blurr bg-blurr2'].join(' ')}>
                                <input type="radio" id="low" name="Enhancements" value="" />
                                <label htmlFor="low">Low Blur</label>
                            </div>
                            <div className={[styles['bg-blurr'], 'col-md-3 bg-blurr bg-blurr2'].join(' ')}>
                                <input type="radio" id="high" name="Enhancements" value="" />
                                <label htmlFor="high">High Blur</label>
                            </div>
                        </div>
                    </div>
                    : null
                }
                <form className={[styles['radio-div'], 'row'].join(' ')}>

                    

                    {props.frontendData.window_tint ?
                        <>
                            <h6><span>Window Tint</span></h6>
                            <CarPostProcessingTint
                                handleTint ={handleTint}
                                tintControl = {tintValue}
                            />
                            {/* {
                               !props.seeThrough ?
                                    <div className={[styles[''], 'col-md-3'].join(' ')}>
                                        <p><input type="radio" name="tint" value="0" defaultChecked={true} onClick={() => props.setCheckTint("0")} />
                                            <span>No Tint</span></p>
                                    </div>
                                    :
                                    null
                            } 
                            <div className={[styles[''],!props.seeThrough? 'col-md-3':'col-md-4'].join(' ')}>
                                <p><input type="radio" name="tint" value="0.28" onClick={() => props.setCheckTint("0.28")} />
                                    <span>Light</span></p>
                            </div>
                            <div className={[styles[''],!props.seeThrough? 'col-md-3 col-3':'col-md-4 col-4'].join(' ')}>
                                <p><input type="radio" name="tint" value="0.32" onClick={() => props.setCheckTint("0.32")} />
                                    <span>Normal</span></p>
                            </div>
                            <div className={[styles[''], !props.seeThrough? 'col-md-3 col-3':'col-md-4 col-4'].join(' ')}>
                                <p><input type="radio" name="tint" value="0.37" onClick={() => props.setCheckTint("0.37")} />
                                    <span>Dark</span></p>
                            </div> */}
                        </>
                        :
                        null
                    }
                    
                    
                    {props.frontendData.colorEnhancements || props.frontendData.see_through ? 
                    <div className="d-flex justify-content-between">
                    <div className={[styles['post-processing-card'] ,"col-6" ].join(' ')} style={{boxShadow:"5px 10px 10px #c4c4c4" ,margin:"auto"}}> 
                        {
                            props.frontendData.colorEnhancements ?
                                <div className="row" onClick={props.handleWindowCorrection}>
                                    <div className="col-12 text-center">
                                        <input type="checkbox" id="color" name="Enhancements" onChange={props.handleWindowCorrection} checked={props.checkWindowCorrection} />
                                        <label className="ml-2"> Glass Enhancements
                                        </label>
                                    </div>
                                    <img className="img col-12" src="https://storage.googleapis.com/spyne-website/static/landing-page/homepage/Group%205894062%20(1).png"></img>
                                </div>
                        
                            : null
                        }
                    </div>
                    {/* <div className={[styles['post-processing-card'], "col-6 ml-2"].join(' ')} style={{boxShadow:"5px 10px 10px #c4c4c4"}}>
                    {
                        props.frontendData.see_through ?
                        <div className="row" onClick={(e) => {props.setSeeThrough(!props.seeThrough);!props.seeThrough?props.setCheckTint("0.37"):props.setCheckTint("0") }}>
                            <div className="col-12 text-center">
                                <input type="checkbox" id="seeThrough" name="seeThrough" onChange={(e) => {props.setSeeThrough(!props.seeThrough);!props.seeThrough?props.setCheckTint("0.37"):props.setCheckTint("0") }} checked={props.seeThrough} />
                                <label htmlFor="seeThrough" className="ml-2">Window See-Through</label>
                            </div>
                            <img className="img col-12" src="https://storage.googleapis.com/spyne-website/static/landing-page/homepage/seethrough_.png"/>
                        </div>
                        :
                        null
                    }

                    </div>  */}

                </div>: null
                    }

                    {/* Brightness Control */}
                    
                    {props.frontendData.brightness ?
                        <>  
                            <CarPostProcessingBrightness
                                handleBrightness ={handleBrightness}
                                brightnessControl = {brightnessControl}
                            />
                        </>
                        :
                        null
                    }
                    {props.frontendData.body_reflection || props.frontendData.colorEnhancements ? 
                    <div className="d-flex justify-content-between">
                    {/* <div className={[styles['post-processing-card'], "col-6"].join(' ')} style={{boxShadow:"5px 10px 10px #c4c4c4" }}>
                        {
                            props.frontendData.colorEnhancements ?
                                <div className="row" onClick={props.handleColorEnhancement}>
                                    <div className="col-12 text-center">
                                        <input type="checkbox" id="color" name="Enhancements" onChange={props.handleColorEnhancement} checked={props.checkColorEnhancement} />
                                        <label  className="ml-2" > Colour Correction</label>
                                    </div>
                                    <img className ="img col-12"  src="https://storage.googleapis.com/spyne-website/static/landing-page/homepage/light.png"/>
                                </div>
                            : null
                        }
                    </div> */}
                    <div className={[styles['post-processing-card'], "col-6"].join(' ')} style={{boxShadow:"5px 10px 20px #c4c4c4" ,margin:"auto"}}>
                        {
                            props.frontendData.body_reflection ?
                            <div className="row" onClick={() => props.setCheckBodyReflection(!props.checkBodyReflection)}>
                                <div className="col-12 text-center">
                                    <input  type="checkbox" id="check" name="Shadow" onChange={() => props.setCheckBodyReflection(!props.checkBodyReflection)} checked={props.checkBodyReflection} />
                                    <label className="ml-2" >Body Reflection</label>
                                </div>
                                <img className="col-12"  src="https://storage.googleapis.com/spyne-website/static/landing-page/homepage/bodyref.png"/>
                            </div>
                            :
                            null
                        }
                    </div>
                </div>: null}
                    

                    
                    {props.frontendData.blur_background ?
                        <>
                            <h6><span>Background Blur</span></h6>
                            <div className={[styles[''], 'col-md-4 col-4'].join(' ')}>
                                <p><input type="radio" name="blur" value="0.28" onClick={() => props.setCheckBlur("0.28")} />
                                    <span>No Blur</span></p>
                            </div>
                            <div className={[styles[''], 'col-md-4 col-4'].join(' ')}>
                                <p><input type="radio" name="blur" value="0.32" onClick={() => props.setCheckBlur("0.32")} />
                                    <span>Low Blur</span></p>
                            </div>
                            <div className={[styles[''], 'col-md-4 col-4'].join(' ')}>
                                <p><input type="radio" name="blur" value="0.37" defaultChecked={true} onClick={() => props.setCheckBlur("0.37")} />
                                    <span>High Blur</span></p>
                            </div>
                        </>
                        :
                        null
                    }
                </form>

                {/* {props.frontendData.windowCorrections || props.frontendData.colorEnhancements || props.frontendData.shadows ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12 border-0'].join(' ')}>
                        <div className={[styles['number-logo'], 'row m-0'].join(' ')}>
                            {props.frontendData.colorEnhancements ?
                                <div className={[styles['bg-blurr'], 'col-md-6 col-6 bg-blurr'].join(' ')}>
                                    <input type="checkbox" id="color" name="Enhancements" onChange={props.handleColorEnhancement} checked={props.checkColorEnhancement} />
                                    <label htmlFor="color"> Colour Enhancements</label>
                                </div>
                                : null
                            }
                            {props.frontendData.windowCorrections ?
                                <div className={[styles['bg-blurr'], 'col-md-6 col-6 bg-blurr'].join(' ')}>
                                    <input type="checkbox" id="window" name="Correction" onChange={props.handleWindowCorrection} checked={props.checkWindowCorrection} />
                                    <label htmlFor="window"> Glass Enhancement</label>
                                </div>
                                : null
                            }
                            
                            {props.frontendData.shadows ?
                                <div className={[styles['bg-blurr'], 'col-md-6 col-6 bg-blurr'].join(' ')}>
                                    <input type="checkbox" id="check" name="Shadow" onChange={props.handleCheckShadow} checked={props.checkShadow} />
                                    <label htmlFor="check"> Shadow </label>
                                </div>
                                : null
                            } 
                            {props.frontendData.body_reflection ?

                                <div className={[styles['bg-blurr'], 'col-md-6 col-6 bg-blurr'].join(' ')}>
                                    <input type="checkbox" id="check" name="Shadow" onChange={() => props.setCheckBodyReflection(!props.checkBodyReflection)} checked={props.checkBodyReflection} />
                                    <label htmlFor="check"> Remove Body Reflection </label>
                                </div>
                                :
                                null
                            }
                            {props.frontendData.see_through ?

                                <div className={[styles['bg-blurr'], 'col-md-6 col-6 bg-blurr'].join(' ')}>
                                    <input type="checkbox" id="seeThrough" name="seeThrough" onChange={(e) => {props.setSeeThrough(!props.seeThrough);!props.seeThrough?props.setCheckTint("0.37"):props.setCheckTint("0") }} checked={props.seeThrough} />
                                    <label htmlFor="seeThrough">Window See-Through</label>
                                </div>

                                :
                                null
                            }
                        </div>
                    </div>
                    : null
                } */}

                {props.frontendData.marketplace ?
                    <div className={[styles['solid-bg'], 'col-md-12 col-lg-12 border-0'].join(' ')}>
                        <h6><span>Choose MarketPlace</span> </h6>
                        <div className={[styles['solid-bg-image2'], 'row m-0'].join(' ')}>

                            {props.marketPlaceList.map((e, i) => {
                                return <div className={props.marketId === e.marketPlace_id ? [styles['solid-image'], styles['active'], 'solid-image active'].join(' ') : [styles['solid-image'], 'solid-image'].join(' ')} onClick={() => props.handleMarketId(e.marketPlace_id)}>
                                    <img src={e.market_place_img} />
                                    <p>{e.marketPlace_name} </p>
                                </div>
                            })}
                        </div>
                    </div>
                    : null
                }



            </div>
            <LogoCropModal
                showlogoCropModal={showlogoCropModal}
                handleCropModal={handleCropModal}
                numberPlateLogoUrl={numberPlateLogoUrl}
                saveCroppedImage={saveCroppedImage}
                handleCroppedLogoBlob={handleCroppedLogoBlob}
            />


        </div>
    )
}

export default VirtualStudio
